export const TESTIMONIALS = [
  {
    id: "regulated",
    industry: "Healthcare",
    quote: "DD Consulting didn't just build the app; they fixed our entire compliance workflow first. They saved us hiring 3 admins.",
    author: "CEO, Healthcare Provider",
    proofStat: "3x Admin Capacity",
    iconType: "shield"
  },
  {
    id: "ventures",
    industry: "FinTech",
    quote: "Our MVP stood up to rigorous investor due diligence because the architecture was enterprise-grade from day one.",
    author: "Founder, FinTech Scale-up",
    proofStat: "Series A Secured",
    iconType: "chart"
  }
];
